import React from 'react';
import './Navbar.css';

export default function Navbar({ user, onLogout }) {
  return (
    <header className="navbar">
      <div className="navbar-left">
        <span className="navbar-username">{user?.name}</span>
      </div>

      <div className="navbar-center">
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo_elharamain.png`}
          alt="شعار الحرمين"
          className="navbar-logo"
        />
        <p className="navbar-subtitle">بطاقات التهنئة بعيد الفطر المبارك</p>
      </div>

      <div className="navbar-right">
        <button className="navbar-logout" onClick={onLogout}>خروج</button>
      </div>
    </header>
  );
}
